module.exports = __webpack_public_path__ + "static/media/footer-bg.9c5f80ed.svg";